import { Button } from 'common-front/src/designSystem/components/button';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { useParams, useTranslate } from 'common/src/util/dependencies/dependencies';
import { HeaventPaths } from 'common/src/util/paths/heaventPaths';
import * as React from 'react';

export const Header = () => {
    const { organizationId } = useParams();
    const translate = useTranslate();

    return (
        <Flex align="center" gap="6">
            <Box color="gray900" css={{ flexGrow: 1 }} fontSize="displayXs" fontWeight="semiBold">
                {translate('r_les_et_permis_27853')}
            </Box>
            <Button to={HeaventPaths.CREATE_ORGANIZATION_PARAMETERS_ROLE(organizationId)}>
                {translate('cr_er_un_nouvea_53551')}
            </Button>
        </Flex>
    );
};
